<script lang="ts">
  import type { Sponsors } from "$types";
  import { is_date_between } from "$lib/dates";
  import { episodeDate } from "$lib/dates";
  import { Confetti } from "svelte-confetti";

  export let sponsor: Sponsors;

  let copied: boolean = false;
  let hover: boolean = false;

  const copy_code = async (code?: string) => {
    if (!navigator.clipboard || !code) return;
    try {
      await navigator.clipboard.writeText(code);
      copied = true;
      setTimeout(async () => {
        copied = false;
      }, 3500);
    } catch (err) {
      console.error("Failed to copy!", err);
    }
  };
</script>

{#if (sponsor.code && is_date_between(sponsor.code_start, sponsor.code_end)) || (sponsor.code && !sponsor.code_start && !sponsor.code_end)}
  <div class="holder">
    <button
      class="code"
      on:click={() => copy_code(sponsor.code)}
      on:mouseenter={() => (hover = true)}
      on:mouseleave={() => (hover = false)}
    >
      <div class="title">CODE</div>
      <div class="text">
        {#if hover && !copied}
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"
              ><rect width="256" height="256" fill="none" /><polyline
                points="168 168 216 168 216 40 88 40 88 88"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="24"
              /><rect
                x="40"
                y="88"
                width="128"
                height="128"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="24"
              /></svg
            > COPY CODE
          </span>
        {:else if copied || (hover && copied)}
          <span> discount code copied!</span>
        {:else}
          {sponsor.code}
        {/if}
      </div>
      {#if sponsor.discount_amount}
        <div class="discount">{sponsor.discount_amount}</div>
      {/if}
      {#if copied}
        <div class="conf">
          <Confetti x={[-0.5, 0.5]} y={[0.25, 1]} amount="30" />
        </div>
      {/if}
    </button>

    {#if sponsor.code && is_date_between(sponsor.code_start, sponsor.code_end)}
      <div class="thru">
        discount valid through
        {#if sponsor.code_end}
          {episodeDate(sponsor.code_end)}
        {/if}
      </div>
    {/if}
  </div>
{/if}

<style>
  .holder {
    background: var(--secondary);
  }

  .code {
    border: none;
    display: flex;
    background: transparent;
    width: 100%;
    font-size: 1rem;
    cursor: pointer;
    color: white;
    font-weight: bold;
    align-items: center;
    position: relative;
  }
  .code:hover {
    background: var(--primary);
  }
  .code .conf {
    position: absolute;
    width: 1rem;
    height: 1rem;
    left: calc(50% - 0.5rem);
    top: 0;
  }
  .code .title {
    border-right: 1px dashed rgba(255, 255, 255, 0.2);
    padding: 0.75rem;
    height: 100%;
    font-weight: bold;
    color: white;
    font-size: 0.75rem;
  }
  .code .discount {
    border-left: 1px dashed rgba(255, 255, 255, 0.2);
    padding: 0.75rem;
    height: 100%;
    font-weight: bold;
    color: white;
    font-size: 0.75rem;
  }
  .code .text {
    text-align: center;
    flex-grow: 1;
    display: flex;
    justify-content: space-around;
  }
  .code .text span {
    font-size: 0.8rem;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }
  .code .text span svg {
    width: 1rem;
    height: 1rem;
  }

  .thru {
    border-top: 1px dashed rgba(255, 255, 255, 0.2);
    font-size: 0.8rem;
    padding: 0.75rem;
    color: rgba(255, 255, 255, 0.95);
    align-items: center;
    font-style: italic;
  }
</style>
